module.exports = __webpack_public_path__ + "static/img/contact.1ede51fa.svg";